import * as d3 from 'd3';

let enrolmentLabel;
function draw(svgContainer, domainPadding, y) {
  const axisPos = -domainPadding - 50;
  d3.select('.enrolment-percent-label').remove();
  enrolmentLabel = svgContainer
    .append('text')
    .attr('class', 'enrolment-percent-label')
    .style('fill', '#404040')
    .style('font-size', '0.75rem')
    .attr('text-anchor', 'left')
    .attr('y', y(y.domain()[1]));

  enrolmentLabel
    .append('tspan')
    .attr('x', axisPos)
    .attr('dy', 0)
    .text('Enrolment');
  enrolmentLabel
    .append('tspan')
    .attr('x', axisPos)
    .attr('dy', '1.2em')
    .text('change (%)');

  update();
}

function update() {
  enrolmentLabel.style('display', d => {
    if (window.matchMedia('(min-width: 600px)').matches) {
      return '';
    }
    return 'none';
  });
}

export default {
  draw,
  update,
};



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/enrolmentPercentLabel.js